// Libs
import React from 'react'

// Utils
import { getTranslatedPlans } from "utils/translatePlanNames";

// Assets
import iconCheck from "newDropshipperApp/images/icon-check.svg";
import chartIcon from "assets/chart-small-icon.svg";

// Static Data
import plansData from "newDropshipperApp/utils/staticData/plansData";

// Style
import {  Container,
          Header,
          Title,
          MobileTitle,
          PlanName,
          Features,
          Feature,
          FeatureText } from "./OrderDetailsStyle";

function OrderDetails({ planName, t }) {
  const planData = plansData().find(plan => plan.name === planName)
  const planFeatures = planData && planData['features']
  return (
    <Container>
      <Header>
        <Title>{t("OrderDetails.Title")}</Title>
        <MobileTitle>
          <img src={chartIcon} alt="chart" /> 
          <p>{t("UpgradeConfirmationModal.Header.Title")}</p>
        </MobileTitle>
        <PlanName>{getTranslatedPlans(planName)}</PlanName>
      </Header>
      <Features>
        {planFeatures.map(feature => (
          <Feature
            key={feature.id}
          >
            <img
              src={iconCheck}
              alt="check"
            />
            <FeatureText>
              <strong>{feature.text.highlight}</strong>{" "}
              {feature.text.description}
            </FeatureText>
          </Feature>
        ))}
      </Features>
    </Container>
  )
}

export default OrderDetails



// WEBPACK FOOTER //
// ./src/newDropshipperApp/component/upgradeConfirmationModal/OrderDetails.js